<template>
  <nav>
    <a v-on:click="toggleMenu" id="menuButton" v-bind:class="{on:isScrolled}">
      <div class="svg">
        <svg aria-hidden="true" data-prefix="fas" data-icon="bars" class="svg-inline--fa fa-bars fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path></svg>
      </div>
      MENU
    </a>
    <div id="menuContent" v-bind:class="{on:isOpen}">
      <a v-on:click="toggleMenu" class="close"><img src="../assets/times-regular.svg" alt=""></a>
      <ul>
        <li><a v-on:click="toggleMenu" href="#app">TOP</a></li>
        <li><a v-on:click="toggleMenu" href="#itemList">商品（やさしくて濃厚なパッケージ）</a></li>
        <li><a v-on:click="toggleMenu" href="#themesong">やさしくて濃厚なテーマソング</a></li>
        <li><a v-on:click="toggleMenu" href="#plan">優しくて濃厚な２泊３日プラン</a></li>
        <li><a href="https://nagasakigoto.net/" target="_blank"><img src="../assets/shopping-cart-regular.svg" alt="" class="cart">ごとオンラインストア</a></li>
      </ul>
      <img src="../assets/footer_logo.png" alt="" class="navLogo">
    </div>
  </nav>
</template>

<script>

export default {
  name: 'Menu',
  data:function(){
    return {
        isOpen: false,
        isScrolled: true,
    }
  },
  mounted: function(){
    let _this = this;
    _this.isScrolled = (window.scrollY > 20);
    window.addEventListener('scroll', function(){
      _this.isScrolled = (window.scrollY > 20);
    })
  },
  methods: {
    toggleMenu: function(){
      this.isOpen = !this.isOpen;
    }
  }
}
</script>

<style scoped>
nav{
  position: fixed;
  top: 0;
  z-index: 900;
  width: 100%;
}
.cart{
  height: 20px;
  position: relative;
  top: -2px;
  margin-right: 10px;
}
#menuButton{
  position: absolute;
  right: 15px;
  top: 14px;
  color: #fff;
  font-size: 10px;
  padding: 5px 10px;
  border: 1px solid #fff;
  border-radius: 5px;
  text-align: center;
  transition: color ease-out 200ms, border ease-out 200ms;
  mix-blend-mode: soft-light;
  /*background: rgba(0,0,0,0.5);*/
}
.svg svg{
  width: 30px;
  fill: #fff;
  transition: fill ease-out 200ms;
}
#menuButton.on{
  color: #022963;
  border-color: #022963;
}
#menuButton.on svg{
  fill: #022963;
}


#menuContent{
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  max-width: 480px;
  background: rgba(255,255,255, 0.95);
  z-index: 9999;
  transition: opacity 200ms ease-out;
  display: none;
}
#menuContent.on{
  display: block;
}
#menuContent ul{
  margin: 80px 0 0;
  padding: 0;
}
#menuContent li{
  list-style: none;
}
#menuContent li:after,
#menuContent li:first-child:before{
  content: " ";
  display: block;
  height: 1px;
  margin: 0 20px;
  background: #000;
}
#menuContent a{
  font-size: 18px;
  font-weight: bold;
  display: block;
  line-height: 2;
  padding: 10px 30px;
  color: #000;
}
.navLogo{
  width: 60px;
  display: block;
  margin: 30px auto;
}
.close{
  position: absolute;
  right: -5px;
  top: 5px;
}
.close img{
  width: 30px;
}
</style>
